import React from 'react';
import PropTypes from 'prop-types';
import Card from '../card';
import Modal from '../modal';

const { gTagEvent } = require('../../../lib/global-site-tag').default;

export default function CardWithEditModal({
  className,
  showCollapseButton,
  showEditButton,
  showShareButton,
  showInfoButton,
  title,
  cardContent,
  largeTitle,
  modalSaveText,
  modalContent,
  onSave,
  isOpen: isOpenProps,
  isLoading,
  handleOnClose: handleOnCloseProps,
  handleOnEditClick: handleOnEditClickProps,
  disableSave,
  minHeight,
  saveConfirmationDialogProps,
}) {
  const [isOpen, setIsOpen] = React.useState(isOpenProps);
  const [showOnSaveConfirmationDialog, setShowOnSaveConfirmationDialog] = React.useState(false);

  React.useEffect(() => {
    setIsOpen(isOpenProps);
  }, [isOpenProps]);

  const handleOnClose = () => {
    if (!showOnSaveConfirmationDialog) {
      handleOnCloseProps();
    }
  };

  const handleOnEditClick = () => {
    gTagEvent(`EDIT ${title} Popup`, 'Open Popup');
    handleOnEditClickProps();
  };

  const handleOnClickSave = (forceSave) => {
    if (saveConfirmationDialogProps && !forceSave) {
      setShowOnSaveConfirmationDialog(true);
      return false;
    }
    gTagEvent(`EDIT ${title} Popup`, 'Save Changes');
    onSave();
    return true;
  };

  return (
    <>
      <Card
        title={title}
        className={className}
        showCollapseButton={showCollapseButton}
        showEditButton={showEditButton}
        showShareButton={showShareButton}
        showInfoButton={showInfoButton}
        largeTitle={largeTitle}
        onEditClick={handleOnEditClick}
        isLoading={isLoading}
        minHeight={minHeight}
      >
        {cardContent}
      </Card>
      <Modal
        show={isOpen}
        saveButtonText={modalSaveText}
        onSave={handleOnClickSave}
        onClose={handleOnClose}
        title={title}
        headerSize="h3"
        disableSave={disableSave}
      >
        {isOpen && modalContent}
      </Modal>
      {saveConfirmationDialogProps ? (
        <Modal
          {...saveConfirmationDialogProps}
          show={showOnSaveConfirmationDialog}
          onClose={() => setShowOnSaveConfirmationDialog(false)}
          onSave={() => handleOnClickSave(true)}
        >
          {saveConfirmationDialogProps.children}
        </Modal>
      ) : null}
    </>
  );
}

CardWithEditModal.propTypes = {
  className: PropTypes.string,
  showCollapseButton: PropTypes.bool,
  showEditButton: PropTypes.bool,
  showShareButton: PropTypes.bool,
  showInfoButton: PropTypes.bool,
  title: PropTypes.node.isRequired,
  cardContent: PropTypes.element.isRequired,
  largeTitle: PropTypes.bool,
  modalSaveText: PropTypes.string,
  modalContent: PropTypes.element.isRequired,
  onSave: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  handleOnClose: PropTypes.func.isRequired,
  handleOnEditClick: PropTypes.func.isRequired,
  disableSave: PropTypes.bool,
  minHeight: PropTypes.number,
  saveConfirmationDialogProps: PropTypes.shape({
    title: PropTypes.string,
    saveButtonText: PropTypes.string,
    children: PropTypes.node,
  }),
};

CardWithEditModal.defaultProps = {
  className: '',
  showCollapseButton: false,
  showEditButton: false,
  showShareButton: false,
  showInfoButton: false,
  largeTitle: false,
  modalSaveText: 'Save Changes',
  isOpen: false,
  isLoading: false,
  disableSave: false,
  minHeight: 0,
  saveConfirmationDialogProps: null,
};
